;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';

import cx from 'clsx';

import { BLOCKS } from '@contentful/rich-text-types';

import RichText from 'components/ui/RichText';
import Text from 'components/ui/Text';

import styles from './TalesBlockParagraph.module.scss';

const richTextOverrides = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return (
                <Text
                    as="p"
                    className={styles.copy}
                    baseTheme="bodySmall"
                    themes={{
                        medium: 'bodyMedium',
                        large: 'bodyLarge',
                    }}
                >
                    {children}
                </Text>
            );
        },
    },
};

const TalesBlockParagraph = ({ copy, richText, isActive, theme }) => {
    const rootRef = useRef(null);
    const [isInView, setIsInView] = useState(false);
    const [isAboveFold, setIsAboveFold] = useState(false);

    const isBoldTheme = theme === 'bold';

    const intersection = useIntersection(rootRef, {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    });

    useEffect(() => {
        if (intersection?.isIntersecting && isActive) {
            setIsInView(true);
        }

        if (!isActive) {
            setIsInView(false);
        }
    }, [intersection, isActive]);

    useEffect(() => {
        const handleResize = () => {
            if (rootRef.current && isActive) {
                const heightAbove = calculateTotalHeightAbove();
                if (heightAbove <= window.innerHeight) {
                    setIsAboveFold(true);
                } else {
                    setIsAboveFold(false);
                }
            }
        };

        const calculateTotalHeightAbove = () => {
            let totalHeight = 0;
            let sibling = rootRef.current.previousElementSibling;

            while (sibling) {
                totalHeight += sibling.offsetHeight;
                sibling = sibling.previousElementSibling;
            }

            return totalHeight;
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isActive]);

    return (
        <section
            ref={rootRef}
            className={cx(styles.root, {
                [styles.isInView]: isInView,
                [styles.isAboveFold]: isAboveFold,
                [styles.isBoldTheme]: isBoldTheme,
            })}
        >
            <div className={styles.inner}>
                {richText && (
                    <RichText
                        richText={richText}
                        overrides={richTextOverrides}
                    />
                )}
                {copy && (
                    <Text
                        as="p"
                        className={styles.copy}
                        baseTheme={'bodySmall'}
                        themes={{
                            medium: 'bodyMedium',
                            large: 'bodyLarge',
                        }}
                    >
                        <span dangerouslySetInnerHTML={{ __html: copy }} />
                    </Text>
                )}
            </div>
        </section>
    );
};

export default TalesBlockParagraph;
